import { DEFAULT_TEMPLATE_RESOLUTION } from 'modules/manager/domain/template-resolutions';
import React from 'react';

interface EditorCanvasSkeletonProps {
  /** Размер шаблона; пока шаблон не пришёл — квадрат 1080×1080, самое частое разрешение. */
  width?: number;
  height?: number;
}

/**
 * Прямоугольник шаблона на месте канвы, пока шаблон грузится и восстанавливается.
 *
 * Повторяет `FabricEditor.fit()` (`fabric-editor/domain/core/fabric-editor.ts`):
 * шаблон вписан в слот целиком, без отступов, и отцентрован. То же самое делает
 * CSS — ширина `min(100cqw, 100cqh · w/h)` в контейнере размера слота плюс
 * `aspect-ratio`. Поэтому после `canvas:loaded` объекты шаблона встают ровно в
 * рамку плашки.
 *
 * Кладётся в `canvasOverlay` у `EditorLayout` — непрозрачным слоем поверх уже
 * смонтированной канвы: без неё не будет `editor`, и восстановление не начнётся.
 */
export const EditorCanvasSkeleton: React.FC<EditorCanvasSkeletonProps> = ({
  width = DEFAULT_TEMPLATE_RESOLUTION.width,
  height = DEFAULT_TEMPLATE_RESOLUTION.height,
}) => {
  const aspectRatio = `${width} / ${height}`;

  return (
    <div className="flex h-full w-full items-center justify-center" style={{ containerType: 'size' }}>
      <div
        className="skeleton-block"
        style={{ width: `min(100cqw, 100cqh * ${width / height})`, aspectRatio }}
        // jsdom не знает `aspect-ratio` и выбрасывает его из `style` — тест читает пропорцию отсюда.
        data-aspect-ratio={aspectRatio}
        data-testid="editor-canvas-skeleton"
        aria-hidden
      />
    </div>
  );
};

export default EditorCanvasSkeleton;
